import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

export default function About() {
  return (
    <div className="container w-full md:w-3/5 lg:w-3/5 xl:w-3/5 2xl:w-3/5">
      <h1 className="font-bold text-xl text-center pb-10">About Us</h1>
      <p className="text-center px-4">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. At recusandae
        delectus voluptate, temporibus obcaecati corporis illo fugit cumque fuga
        rerum vitae quia omnis unde fugiat nihil tenetur laborum officiis
        excepturi.
      </p>
    </div>
  );
}
